import api from 'Application/api/api';

const updateEpcPartner = (signal, values) =>
	api.put('/epcpartners', values, {
		signal,
	});

export default updateEpcPartner;
